import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tooltip, Card, CardContent, Typography, Grid, Box, TextField, MenuItem, Select, InputLabel, FormControl, Slider, IconButton, Button, skeleton, Avatar } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import StarIcon from '@mui/icons-material/Star';  // Import Star icon for rating
import FilterListIcon from '@mui/icons-material/FilterList'; // Import the filter icon
import VisibilityIcon from '@mui/icons-material/Visibility';
import avatar from '../Post/default-avatar.png'
import ShareIcon from '@mui/icons-material/Share';
import { AccessTime } from '@mui/icons-material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // Import the rupee icon
import Header1 from "../Header/Header1";
import { Masonry } from '@mui/lab';
import Vidya from "./Vidya";

const API_URL = process.env.REACT_APP_API_URL;



function OverallSessions({ userId, onLogout }) {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const [sections, setSections] = useState([]);
  const [subsections, setSubsections] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({
    rating: 0,
    date: "",
    time: "",
    cost: [0, 500], // Cost range slider
    language: "",
    duration: [0, 120], // Duration range slider in minutes
    sectionId: "",  // Store section ID
    subsectionId: "",  // Store subsection ID
  });

  const [page, setPage] = useState(1);  // Start with page 1
  const [allFetched, setAllFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [tempDate, setTempDate] = useState(filters.date || "");

  const handleApplyClick = () => {
    handleFilterChange({ target: { value: tempDate } }, "date");
  };

  const buildQuery = () => {
    let query = `?user_id=${userId}&page=${page}`;

    if (filters.rating) query += `&rating=${filters.rating}`;
    if (filters.date) query += `&date=${filters.date}`;
    if (filters.time) query += `&time=${filters.time}`;
    if (filters.language) query += `&language=${filters.language}`;
    if (filters.cost) query += `&min_cost=${filters.cost[0]}&max_cost=${filters.cost[1]}`;
    if (filters.duration) query += `&min_duration=${filters.duration[0]}&max_duration=${filters.duration[1]}`;
    if (filters.sectionId) query += `&section_id=${filters.sectionId}`;
    if (filters.subsectionId) query += `&subsection_id=${filters.subsectionId}`;

    return query;
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${API_URL}/list_posted_data/${buildQuery()}`);

      if (response.data.length === 0) {
        setAllFetched(true);  // Stop fetching if no new data
      } else {
        setSections((prevSections) => {
          const newSections = response.data.filter(
            (newSection) => !prevSections.some((section) => section.id === newSection.id)
          );
          return [...prevSections, ...newSections];
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(1);
    setAllFetched(false);
    setSections([]);
  }, [filters]);

  // Fetch data on page change or when filters change
  useEffect(() => {
    if (!allFetched) {
      fetchData();
    }
  }, [filters, userId, page]); // Dependencies include page and filters

  // Handle scroll event to detect when the user has scrolled to the bottom
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (windowHeight + scrollPosition >= documentHeight - 1 && !loading && !allFetched) {
      setPage((prevPage) => prevPage + 1);  // Increment the page to load next data
    }
  };

  // Add event listener for scroll on component mount and cleanup on unmount
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [loading, allFetched]);

  const extractLanguages = (data) => {
    const allLanguages = new Set();

    data.forEach(item => {
      allLanguages.add(item.name);
    });

    setLanguages([...allLanguages]);
  };


  const navigate = useNavigate();

  const allCards = sections

  const handleFilterChange = (event, filterType) => {
    setFilters({
      ...filters,
      [filterType]: event.target.value,
    });
  };
  const handleSliderChange = (event, newValue, filterType) => {
    if (Array.isArray(newValue)) {
      setFilters({
        ...filters,
        [filterType]: newValue,
      });
    } else {
      // For single value filters
      setFilters({
        ...filters,
        [filterType]: newValue,
      });
    }
  };

  const filteredCards = allCards.filter(card => {
    const matchesRating = filters.rating ? card.rating >= filters.rating : true;
    const matchesDate = filters.date ? card.date === filters.date : true;
    const matchesTime = filters.time ? card.starttime === filters.time : true;
    const matchesCost = card.price >= filters.cost[0] && card.price <= filters.cost[1];
    const matchesLanguage = filters.language ? card.language === filters.language : true;
    const matchesDuration = true; // Implement duration filter logic here

    return matchesRating && matchesDate && matchesTime && matchesCost && matchesLanguage && matchesDuration;
  });


  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await fetch(`${API_URL}/list_sections_and_subsections/`);
        const data = await response.json();
        const formattedSections = Object.keys(data.sections).map((key) => ({
          section_id: data.sections[key].section_id,
          section_name: key,
          subsections: data.sections[key].subsections || [],
        }));
        setCategories(formattedSections);
        extractLanguages(data.languages);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchSections();
  }, []);


  const handleSearch = (result) => {
    setSections(result)
    // setData(result)
  }

  const handleClearFilters = () => {
    setFilters({
      rating: 0,
      date: "",
      time: "",
      cost: [0, 500], // Cost range slider
      language: "",
      duration: [0, 120], // Duration range slider in minutes
      sectionId: "",  // Store section ID
      subsectionId: "",  // Store subsection ID
    })
    setAllFetched(false);

  }

  const handleSectionChange = (event) => {
    const selectedSectionId = event.target.value;
    setFilters((prev) => ({
      ...prev,
      sectionId: selectedSectionId,
      subsectionId: ''  // Reset subsection when section changes
    }));

    // Find the subsections corresponding to the selected section
    const selectedSection = categories.find(
      (category) => category.section_id === selectedSectionId
    );
    setSubsections(selectedSection ? selectedSection.subsections : []);
  };

  const handleSubsectionChange = (event) => {
    setFilters((prev) => ({
      ...prev,
      subsectionId: event.target.value
    }));
  };

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <Box sx={{ padding: "1rem", backgroundColor: "#11111", minHeight: "100vh", mt: -5, ml: { xs: 0, sm: 5 }, }}>
      <Box
        sx={{
          position: 'fixed', // or 'relative' / 'sticky' based on your layout
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1300, // higher than MUI drawers (default is 1200)
        }}
      >
        <Header1 userId={userId} onLogout={onLogout} />
      </Box>
      <Box
      elevation={6}
      sx={{
        position: 'fixed',
        bottom: 200,
        right: 60,
        width: 400,
        height: 700,
        zIndex: 1300,
        borderRadius: 2,
        overflow: 'hidden',
      }}
    ><Vidya page_name="posted"/></Box>
      

      <Tooltip title="Filter Panel" placement="left">
        <IconButton
          onClick={() => setShowFilters(!showFilters)}
          sx={{
            color: "#ffffff",
            position: "fixed",  // Absolutely position it within the parent box
            top: "70px",            // Add some spacing from the top
            right: "10px",          // Add some spacing from the right edge
            zIndex: 20,
            "&:hover": {
              color: "#1E90FF",  // Icon color on hover
            },
          }}
        >
          <FilterListIcon />
        </IconButton>
      </Tooltip>

      {showFilters && (
        <Box sx={{
          position: "fixed",
          top: "60px",
          right: "0",
          width: "300px",
          height: "100%",
          backgroundColor: "#000000",
          padding: "1rem",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.4)",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          borderRadius: "8px",
          zIndex: "10",

        }}>


          <FormControl sx={{ width: "100%", marginBottom: "1rem", marginTop: "2rem" }}>
            <InputLabel sx={{ color: "#ffffff", letterSpacing: 2, }}>Rating</InputLabel>
            <Select
              value={filters.rating}
              label="Rating"
              onChange={(e) => handleFilterChange(e, "rating")}
              sx={{
                backgroundColor: "#2222",
                color: "#ffffff",
                letterSpacing: 2,
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                }
              }}
            >
              {[0, 1, 2, 3, 4, 5].map((rating) => (
                <MenuItem key={rating} value={rating} sx={{ letterSpacing: 2, }}>
                  {rating}+
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginBottom: "1rem",
                flexWrap: "wrap",
              }}
            >
              <TextField
                type="date"
                value={tempDate}
                onChange={(e) => setTempDate(e.target.value)}
                sx={{
                  backgroundColor: "#2222",
                  color: "#ffffff",
                  letterSpacing: 2,
                  "& .MuiInputBase-root": {
                    color: "#ffffff",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#2222",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#1E90FF",
                  },
                  flexGrow: 1,
                }}
              />
              <Button
                variant="contained"
                onClick={() => {
                  setFilters((prev) => ({
                    ...prev,
                    date: tempDate,
                  }));
                }}
              >
                Apply
              </Button>
            </Box>


          </Box>
          {/* Language Filter */}
          <FormControl sx={{ width: "100%", marginBottom: "1rem" }}>
            <InputLabel sx={{ color: "#ffffff", letterSpacing: 2, }}>Language</InputLabel>
            <Select
              value={filters.language}
              label="Language"
              onChange={(e) => handleFilterChange(e, "language")}
              sx={{
                backgroundColor: "#2222",
                letterSpacing: 2,
                color: "#ffffff",
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                }
              }}
            >
              <MenuItem value="" sx={{ letterSpacing: 2, }}>Select Language</MenuItem>
              {languages.map((lang, index) => (
                <MenuItem key={index} value={lang} sx={{ letterSpacing: 2, }}>
                  {lang}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ width: "100%", marginBottom: "1rem" }}>
            <Typography gutterBottom sx={{ color: "#ffffff", letterSpacing: 2, }}>Duration</Typography>
            <Slider
              value={filters.duration}
              onChange={(e, newValue) => handleSliderChange(e, newValue, "duration")}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => `${value} mins`}
              min={0}
              max={120}
              step={10}
              sx={{
                color: "#1E90FF",
                letterSpacing: 2,
                "& .MuiSlider-thumb": {
                  backgroundColor: "#1E90FF",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "#555555",
                },
                "& .MuiSlider-track": {
                  backgroundColor: "#1E90FF",
                }
              }}
            />
          </Box>
          {/* Cost Filter */}
          <Box sx={{ width: "100%", marginBottom: "1rem" }}>
            <Typography gutterBottom sx={{ color: "#ffffff", letterSpacing: 2, }}>Cost</Typography>
            <Slider
              value={filters.cost}
              onChange={(e, newValue) => handleSliderChange(e, newValue, "cost")}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => `₹ ${value}`}
              min={0}
              max={500}
              step={10}
              sx={{
                color: "#1E90FF",
                letterSpacing: 2,
                "& .MuiSlider-thumb": {
                  backgroundColor: "#1E90FF",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "#555555",
                },
                "& .MuiSlider-track": {
                  backgroundColor: "#1E90FF",
                }
              }}
            />
          </Box>

          <Box sx={{}}>
            <Button
              onClick={handleClearFilters}
              variant="outlined"
              sx={{
                width: "100%",
                color: "#1E90FF",
                letterSpacing: 2,
                borderColor: "#1E90FF",
                "&:hover": {
                  backgroundColor: "#1E90FF",
                  color: "#fff"
                }
              }}
            >
              Clear Filters
            </Button>
          </Box>

        </Box>
      )}
      {/* Filter Bar */}
      <Box sx={{ marginRight: showFilters ? "75px" : "0", transition: "margin-right 0.3s", }}>
        {/* Cards Section */}
        <Box
  sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    mt: 2,
  }}
>
  {allCards.map((card, index) => (
    <Tooltip title="Click to View" placement="top" key={index}>
      <Link
        to={`/post-tab-details/${card.id}/${userId}`}
        style={{ textDecoration: 'none', width: '100%' }}
      >
        <Box
          sx={{
            backdropFilter: 'blur(10px)',
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '20px',
            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
            transition: '0.3s ease',
            '&:hover': {
              transform: 'translateY(-5px)',
              boxShadow: '0 16px 30px rgba(0, 0, 0, 0.4)',
              border: '1px solid',
              borderImage: 'linear-gradient(45deg, #00bcd4, #8e24aa) 1',
            },
            width: {
              xs: '90%',
              sm: '70%',
              md: '60%',
              lg: '50%',
              xl: '40%',
            },
            marginBottom: 4,
            padding: 3,
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mx: 'auto',
          }}
        >
         {card.media_type === 'video' ? (
  <Box
    component="video"
    src={card.media_url}
    controls
    sx={{ width: '100%', borderRadius: '12px', boxShadow: 3, mb: 2 }}
  />
) : (
  <Box
    component="img"
    src={card.media_url}
    alt="media"
    sx={{ width: '100%', borderRadius: '12px', boxShadow: 3, mb: 2 }}
  />
)}



          {/* Avatar + Name in a row */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              mb: 2,
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <Avatar
              src={`${API_URL}${card.image}` || '/default-avatar.png'}
              alt={card.teacher || 'User'}
              sx={{ width: 50, height: 50 }}
            />
            <Typography
              variant="h6"
              sx={{
                color: 'white',
                fontWeight: 600,
                fontSize: '1.1rem',
                letterSpacing: 1,
              }}
            >
              {(card.teacher + ' ' + card.surname).length > 40
                ? (card.teacher + ' ' + card.surname).slice(0, 40) + '...'
                : card.teacher + ' ' + card.surname}
            </Typography>
          </Box>

          <Typography
            variant="body1"
            sx={{
              color: '#ccc',
              textAlign: 'center',
              mb: 2,
              fontSize: '1rem',
              px: 1,
            }}
          >
            {card.highlightedTopic.length > 100
              ? `${card.highlightedTopic.slice(0, 100)}...`
              : card.highlightedTopic}
          </Typography>

          <Button
            variant="contained"
            sx={{
              fontSize: '1rem',
              padding: '12px 24px',
              borderRadius: '10px',
              backgroundImage: 'linear-gradient(to right, #2196F3, #21CBF3)',
              color: '#fff',
              transition: '0.3s ease',
              '&:hover': {
                backgroundImage: 'linear-gradient(to right, #21CBF3, #2196F3)',
                transform: 'scale(1.05)',
              },
              width: '100%',
              maxWidth: '300px',
            }}
          >
            Book Now
          </Button>
        </Box>
      </Link>
    </Tooltip>
  ))}
</Box>

      </Box>
    </Box >
  );
}
export default OverallSessions;